import React from 'react';
import { useLocation } from 'react-router-dom';
import useWindowDimensions from '../../../../../hooks/useWindowDimensions';
import BookingNavigation from '../../../../pages/booking/components/bookingNavigation/BookingNavigation';
import { useBooking } from '../../../../../contexts/ticketBookingContext/TicketBookingContext';

function TicketBookingDrawer() {
  const { width } = useWindowDimensions();
  const location = useLocation();

  const { activeStep, steps, bookingData } = useBooking();

  const isReturnWay = Boolean(bookingData?.return?.id);

  const makeFixed = () => {
    if (activeStep === 1) {
      return true;
    }

    if (isReturnWay && activeStep === 2) {
      return true;
    }

    return steps.length === activeStep;
  };

  return (
    <div className={`${(width < 1024 && location.pathname.includes('/search/booking')) ? 'block z-[100]' : 'hidden'} ${makeFixed() ? 'fixed w-screen' : 'w-full rounded-3xl'} bg-white  p-5 left-0 bottom-0 rounded-t-3xl shadow-2xl`}>
      <BookingNavigation outline={false} />
    </div>
  );
}

export default TicketBookingDrawer;
